"use strict";

import Page from "./EditEventProperties.jsx";

export const auth = true;
export const title = "i18n:eventProperties.pageTitle";
export const Component = Page;
